export const DOOH_REPORT_SUMMARY_LOADED = "DOOH_REPORT_SUMMARY_LOADED";
export const DETAIL_SUMMARY_REPORT = "DETAIL_SUMMARY_REPORT";
export const DAILY_SUMMARY_REPORT = "DAILY_SUMMARY_REPORT";
export const WEBSITE_SUMMARY_REPORT = "WEBSITE_SUMMARY_REPORT";
export const BANNER_SUMMARY_REPORT = "BANNER_SUMMARY_REPORT";


export const END_URL = {
    DETAIL_SUMMARY_REPORT: '/3/dsp/detail',
    DAILY_SUMMARY_REPORT: '/3/dsp/daily',
    WEBSITE_SUMMARY_REPORT: '/3/dsp/website',
    BANNER_SUMMARY_REPORT: '/3/dsp/banner',

}

export const TOAST_LABEL = {
    SELECT_ADVERTISER:"Please select advertiser",
    SWITCH_TABLE_TYPE:"Please switch the table type"
};

export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
}

export const GET_SUMMARY = "GET_SUMMARY";